import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.17 1.25h-.34a6.74 6.74 0 0 0 0 13.48h.34a6.74 6.74 0 0 0 0-13.48Zm5 6h-2.44A13 13 0 0 0 10 3.13a5.23 5.23 0 0 1 3.19 4.12ZM6 3.13a13 13 0 0 0-.75 4.12H2.81A5.23 5.23 0 0 1 6 3.13ZM2.81 8.75h2.46a12.86 12.86 0 0 0 .73 4.1 5.26 5.26 0 0 1-3.19-4.1ZM8 13.24c-.33-.15-1.11-1.66-1.23-4.49h2.46c-.12 2.89-.92 4.4-1.23 4.49Zm-1.23-6c.11-2.85.9-4.37 1.23-4.5.33.12 1.12 1.64 1.23 4.5ZM10 12.85a12.86 12.86 0 0 0 .75-4.1h2.46a5.22 5.22 0 0 1-3.21 4.1Z';
const draw24px =
  'M12.06,20.29h0ZM21.79,12A9.78,9.78,0,0,1,2.84,15.43v0a2.49,2.49,0,0,1-.11-.29,9.8,9.8,0,0,1,0-6.24l.09-.24a.11.11,0,0,1,0-.07,9.78,9.78,0,0,1,19,3.43Zm-7.5-8a13.94,13.94,0,0,1,1.2,4.21h3.9A8.37,8.37,0,0,0,14.29,4ZM10,8.24h4c-.46-3-1.42-4.53-2-4.53S10.48,5.28,10,8.24Zm-.18,1.5c-.07.7-.1,1.45-.1,2.26s0,1.56.1,2.26h4.33c.07-.7.1-1.45.1-2.26s0-1.56-.1-2.26Zm4.15,6H10c.47,3,1.43,4.52,2,4.52h0C12.56,20.28,13.52,18.71,14,15.76ZM4.62,8.24H8.5A13.93,13.93,0,0,1,9.71,4,8.32,8.32,0,0,0,4.62,8.24Zm-.6,6H8.33c-.07-.74-.1-1.5-.1-2.26s0-1.52.1-2.26H4a8.39,8.39,0,0,0,0,4.52ZM9.72,20A13.47,13.47,0,0,1,8.5,15.76H4.62A8.28,8.28,0,0,0,9.72,20Zm9.67-4.21h-3.9A13.76,13.76,0,0,1,14.28,20,8.33,8.33,0,0,0,19.39,15.76Zm.59-1.5a8.39,8.39,0,0,0,0-4.52H15.67c.06.74.09,1.5.09,2.26s0,1.52-.09,2.26Zm-8,6h0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GlobeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'globe'),
) as IconWithRender;

GlobeIcon.displayName = 'GlobeIcon';
GlobeIcon.propTypes = Icon.propTypes;
GlobeIcon.renderIcon = (props) => <GlobeIcon {...props} />;
export default GlobeIcon;
